import moment from "moment";

import { ServicePossibility } from "@/Appointments/Models/OptimizedAppointment/ServicePossibility";
import { Guid } from "@/Common/Models/Guid";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";

class PredefinedAppointmentItem {
    public PredefinedAppointmentId: Guid;
    public SiteId: Guid;

    public IsFromRuleSetAvailability: boolean;

    public EmployeeId: Guid;
    public Start: string;
    public Duration: number;

    public Subject: string;
    public Name: string;
    public ServiceDefinitionId: Guid;
    public IsNotifyPatientDisabled: boolean;
    public IsTeleconsultation: boolean;

    public SearchResult: string;
    public IsInEditMode: boolean;

    // Default Value for client side only
    public DefaultName: string;
    public DefaultServiceDefinitionId: Guid;
    public DefaultDuration: number;

    public AvailableServiceDefinitionIds: string[];

    public IsFromPortalSearch: boolean;

    public HasQuestionnaire: boolean;

    public QuestionnaireId: string | null;

    // FOR OPTIMIZED SEARCH RESULT.
    public key: string; // Only OptimizedSearch have RandomKey, Old Search Groups items by Generating Keys on the fly that are based on the Start/End

    constructor(fields?: Partial<PredefinedAppointmentItem>) {
        Object.assign(this, fields);

        if (!this.key)
            this.key = sessionStore.newId().toString();
    }

    public GetEnd(): Date {
        const endDate = moment(this.Start).toDate();

        endDate.setMinutes(endDate.getMinutes() + ((this.Duration || this.DefaultDuration) / 600000000));

        return endDate;
    }

    public static FromServicePossibility(
        servicePossibility: ServicePossibility,
        comboDefinition: ServiceComboDefinitionModel | null,
        availableServiceDefinitionIds?: string[]
    ): PredefinedAppointmentItem {
        const serviceDefinition = cacheStore.GetServiceDefinitionById(servicePossibility.ServiceDefinitionId);

        const duration = (new Date(servicePossibility.EndTime).valueOf() - new Date(servicePossibility.StartTime).valueOf()) * 10000;

        const notifyPatientDisabled = comboDefinition?.Model.IsNotifyPatientDisabledByDefault
            ?? serviceDefinition?.Model.IsNotifyPatientDisabledByDefault
            ?? false;

        const questionaireId = (comboDefinition || serviceDefinition)?.GetQuestionnaireId();

        return new PredefinedAppointmentItem({
            SiteId: servicePossibility.SiteId,
            EmployeeId: servicePossibility.EmployeeId,
            Name: serviceDefinition?.Name ?? "",
            DefaultName: serviceDefinition?.Name ?? "",
            ServiceDefinitionId: servicePossibility.ServiceDefinitionId,
            DefaultServiceDefinitionId: servicePossibility.ServiceDefinitionId,
            IsNotifyPatientDisabled: notifyPatientDisabled,
            Start: servicePossibility.StartTime,
            Duration: duration,
            DefaultDuration: duration,
            IsTeleconsultation: !!serviceDefinition?.Model.IsTeleconsultation,
            IsFromPortalSearch: true,
            IsInEditMode: false,
            AvailableServiceDefinitionIds: availableServiceDefinitionIds,
            HasQuestionnaire: !!questionaireId,
            QuestionnaireId: questionaireId
        });
    }
}

export { PredefinedAppointmentItem };
